import React from 'react';
import styles from './styles.css';
import {observer, inject} from 'mobx-react';

function Login({view}) {
  return (
    <div className={styles.login}>
      <h1>Please LOG IN</h1>
      <i onClick={() => view.signIn()} className="material-icons">account_box</i>
    </div>
  );
}

export default inject('view')(observer(Login));



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx